import { FC, HTMLAttributes, useMemo } from 'react'
import styles from 'components/atoms/inputs/Select/ItemPlain/ItemPlain.styl'
import cn from 'classnames'

type ItemPlainProps =
  & HTMLAttributes<HTMLDivElement>
  & {
    highlighted?: boolean
    selected?: boolean
  }
export const ItemPlain: FC<ItemPlainProps> = (props) => {
  const { selected, highlighted, className, children, ...restProps } = props
  const itemClassName = useMemo(() => {
    return cn(styles.itemPlain, {
      [styles.selected]: selected,
      [styles.highlighted]: highlighted,
    }, className)
  }, [className, highlighted, selected])

  return (
    <div className={ itemClassName } { ...restProps }>
      { children }
    </div>
  )
}
